import "styles/page.css";
import { handleOpenPdf } from "utils";
import { LinkButton } from "components/buttons";
import { ASSETS_BASE_URL } from "constants";
function Whistleblow() {
  return (
    <>
      <div className="container page">
        <h1 className="page-title">Whistleblowing Policy</h1>

        <p className="page-subtitle">
          As part of Al Rajhi Banking & Investment Corporation (Malaysia)
          Berhad's commitment to demonstrate exemplary corporate governance
          standards, ARBM has emplaced the Whistleblowing Policy where any
          employee, vendor, supplier or agent of the Bank or general public can
          report, alleged irregularities regarding any misdeeds or malpractices
          within the Bank.
          <br></br>
          <br></br>
          This page provides ARBM's Whistleblowing Policy and FAQ for employees,
          vendors, and members of the public to disclose any improper conduct
          committed or about to be committed by anyone connected with ARBM.
        </p>

        <div className="link-button-row">
          <LinkButton
            text={"Whistle Blower Report Form"}
            onClick={() => {
              handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/Whistleblower_Form.pdf`);
            }}
          />
          <LinkButton
            text={"FAQs"}
            onClick={() => {
              handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/Whistleblower_Faq.pdf`);
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Whistleblow;
